import Group from '../group.js';

/**
 * Create the action
 */

const { thunk, request, success, error } = Group.store((data, fetch) =>
    fetch.post('groups', data)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
